import { kf1AuthenticatedHttpClient} from "kfone-frontend-core";
import { API_URL, API_METHODS } from "../constants/api.constants";
import { AppEnvVariables } from "../constants/environment.constants";
import { getLanguageCode } from "../utilities/helper";

const getCurrencyList = async () => {
  let language = getLanguageCode();
  const config: any = {
    method: API_METHODS.GET,
    url:
      AppEnvVariables.SJPR_API_URL +
      API_URL.COUNTRY_CURRENCY +
      "?language=" +
      language
  };
  return await kf1AuthenticatedHttpClient(config);
};

export { getCurrencyList };
